import { OnInit } from "@angular/core";
import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { FilterModel, SearchCache } from "src/common/components";
import { SupplierRoundListService, WidgetsService } from "src/common/services";
import { UnreadMessagesModel } from "src/common/services/widgets/widget.model";
import { TranslationManager } from "src/common/translation";

@Component({
  selector: 'inbox-supplier-offers-widget',
  templateUrl: './inbox-supplier-offers-widget.component.html'
})
export class InboxSupplierOffersWidgetComponent implements OnInit {

  value: number;
  loading: boolean = false;
  translationManager = TranslationManager;
  unreadMessages: UnreadMessagesModel[];

  constructor(private widgetsService: WidgetsService, private router: Router) { }

  ngOnInit(): void {
    this.loading = true;
    this.widgetsService.getUnreadSupplierOfferMessages().then((result: UnreadMessagesModel[]) => {
      this.unreadMessages = result;
      this.value = result.reduce((sum, current) => sum + current.numberOfMessages, 0);
    }).finally(() => {
      this.loading = false;
    });
  }

  onClick() {
    if (this.value > 0) {
      SearchCache.clear();
      SearchCache.Filters = [];
      this.unreadMessages.forEach(e => {
        SearchCache.Filters.push({ entity: "RequestId", value: e.entityId.toString().trim(), action: "equals" })
      });
      SearchCache.Filters.push({ entity: "RequestRoundStatusUniqueIdentifier", value: 'Initiated', action: "equals" });

      this.router.navigate(['/supplier-rounds']);
    }
  }
}
